import API from './network/http';
import SongService from '../features/songs/song_services';
import { transformExternalSongs } from './transformExternalSongs';

// Internal DB
async function searchInternalSongs(query: string): Promise<any[]> {
    const { data } = await SongService.searchSongs({ query });
    return data.song || [];
}

// RapidAPI (fallback)
async function searchSpotifyViaRapidAPI(query: string): Promise<any[]> {
    const options = {
        method: 'GET',
        url: 'https://spotify23.p.rapidapi.com/search/',
        params: {
            q: query,
            type: 'tracks',
            offset: '0',
            limit: '10',
            numberOfTopResults: '1',
        },
        headers: {
            'X-RapidAPI-Key': process.env.REACT_APP_RAPIDAPI_KEY,
            'X-RapidAPI-Host': 'spotify23.p.rapidapi.com',
        },
    };

    const response = await API.request(options);
    const tracks = response.data?.tracks?.items || [];
    return transformExternalSongs(tracks);
}

// Spotify via backend proxy
async function searchSpotifyViaBackend(query: string): Promise<any[]> {
    const response = await API.get(`/search/external?q=${encodeURIComponent(query)}`);
    return response.data?.songs || [];
}

// Dedupe logic
function mergeAndDedupeSongs(internal: any[], external: any[]): any[] {
    return [
        ...internal,
        ...external.filter(
            (ext) => !internal.some(
                (int) => int.title === ext.title && int.artist === ext.artist
            )
        ),
    ];
}

const providers:{
    [key: string]: (query: string) => Promise<any[]>;
} = {
    rapidapi: searchSpotifyViaRapidAPI,
    spotify: searchSpotifyViaBackend,
    // backend: searchInternalSongs,
};

// Main orchestrator
export async function searchSongsUnified(query: string, source = 'spotify'): Promise<any[]> {
    if (!query || query.length < 2) return [];

    try {
        const internalSongs = await searchInternalSongs(query);
        if (internalSongs.length >= 5) return internalSongs;

        const selectedProvider = providers[source] || providers.spotify;
        const externalSongs = await selectedProvider(query);

        return mergeAndDedupeSongs(internalSongs, externalSongs);
    } catch (error) {
        console.error('Song search failed:', error);
        return [];
    }
}